export default {
  path: '/tool_head_subs',
  name: 'tool_head_subs',
  component: () => import('../components/toolheadsub/Layout'),
  redirect: { name: 'ToolHeadSubList' },
  children: [
    /*
    {
      name: 'ToolHeadSubList',
      path: '',
      component: () => import('../views/toolheadsub/List')
    },
    {
      name: 'ToolHeadSubCreate',
      path: 'new',
      component: () => import('../views/toolheadsub/Create')
    },
    {
      name: 'ToolHeadSubUpdate',
      path: ':id/edit',
      component: () => import('../views/toolheadsub/Update')
    },

    {
      name: 'ToolHeadSubShow',
      path: ':id',
      component: () => import('../views/toolheadsub/Show')
    }
    */
  ]
};
